// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rw-widget-container {
  border: 1px solid var(--LowEmphasis) !important;
  box-shadow: none !important; }
  .rw-widget-container:focus, .rw-widget-container:active {
    border-color: #212121 !important;
    outline: none !important; }

.rw-popup-container {
  box-shadow: none !important;
  width: 100% !important; }

.cameras {
  width: 100%;
  height: 100%; }
  .cameras__button {
    padding: 4px 20px;
    text-align: center;
    background: #fe6100;
    border-radius: 4px;
    color: #ffffff;
    border: none;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.5s; }
    .cameras__button:hover {
      background: #833505; }
    .cameras__button_cancel {
      padding: 4px 20px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      color: #fe6100;
      border: none;
      font-size: 14px;
      line-height: 24px;
      cursor: pointer;
      transition: all 0.5s; }
      .cameras__button_cancel:hover {
        color: #ffffff;
        background: #fe6100; }
  .cameras__preloader {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    width: 100vw;
    height: 100vh;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000; }
  .cameras__settingsLil {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: #00000070;
    backdrop-filter: blur(2px);
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center; }
  .cameras__settings {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: #00000070;
    backdrop-filter: blur(2px);
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center; }
    .cameras__settings_test {
      width: 100%;
      border: 2px solid #e0e0e0;
      border-radius: 4px;
      color: #fe6100;
      padding: 4px 0;
      text-align: center;
      transition: all 0.4s;
      cursor: pointer; }
      .cameras__settings_test:hover {
        background-color: #fe6100;
        color: #ffffff; }
    .cameras__settings_text {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #9e9e9e; }
    .cameras__settings_buttons {
      display: flex;
      gap: 15px;
      position: absolute;
      bottom: 8px;
      right: 20px; }
    .cameras__settings h6 {
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      color: #9e9e9e;
      margin-bottom: 10px; }
    .cameras__settings .sysSettings {
      border-top: 1px solid #E0E0E0;
      width: 100%;
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      color: #9e9e9e;
      padding: 10px 0; }
    .cameras__settings_modal {
      position: relative;
      width: calc(100% - 300px);
      height: calc(90vh);
      margin-top: 70px;
      background-color: #ffffff;
      padding: 20px;
      display: flex;
      flex-direction: column; }
    .cameras__settings_modalLIL {
      position: relative;
      background-color: #ffffff;
      padding: 20px;
      display: flex;
      flex-direction: column; }
    .cameras__settings_img {
      width: 100%;
      height: 192px;
      object-fit: contain;
      object-position: center bottom; }
      .cameras__settings_img_bad {
        width: 100%;
        height: 100%;
        background: #f5f5f5;
        border: 2.54033px solid #e0e0e0;
        border-radius: 4px; }
    .cameras__settings_header {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 10px; }
      .cameras__settings_header h1 {
        font-weight: 600;
        font-size: 24px;
        line-height: 150%; }
    .cameras__settings_descLIL {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px; }
      @media screen and (max-width: 1361px) {
        .cameras__settings_descLIL {
          font-weight: 400;
          font-size: 15px;
          line-height: 20px; } }
      @media screen and (max-width: 970px) {
        .cameras__settings_descLIL {
          font-weight: 400;
          font-size: 13px;
          line-height: 14px; } }
    .cameras__settings_ipLIL {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px; }
    .cameras__settings_container {
      width: 100%;
      height: calc(90vh - 170px);
      display: flex;
      border-bottom: 1px solid #e0e0e0; }
    .cameras__settings_containerLIL {
      width: 100%;
      height: 440px;
      display: flex; }
    .cameras__settings_right {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding-left: 20px; }
    .cameras__settings_left {
      min-width: calc(100% - 380px);
      width: calc(100% - 380px);
      padding: 0 12px 0 0;
      border-right: 1px solid #e0e0e0;
      overflow: auto; }
    .cameras__settings_inputs {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 30px; }
      .cameras__settings_inputs label {
        margin-bottom: 6px; }
      @media screen and (max-height: 675px) {
        .cameras__settings_inputs {
          margin-bottom: 20px; } }
      .cameras__settings_inputs_connection {
        width: 100% !important;
        margin-bottom: 10px;
        position: relative;
        background: #f3f4f6;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        padding: 7px 10px; }
        .cameras__settings_inputs_connection h6 {
          color: #9e9e9e;
          font-weight: 600;
          font-size: 12px;
          margin: 0; }
        .cameras__settings_inputs_connection h5 {
          color: #666666;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px; }
        .cameras__settings_inputs_connection_edit {
          position: absolute;
          right: 10px;
          top: calc(50% - 12px);
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          color: #fe6100;
          cursor: pointer;
          transition: all 0.4s; }
          .cameras__settings_inputs_connection_edit:hover {
            text-decoration: underline; }
      .cameras__settings_inputs > div {
        width: 48%;
        display: flex;
        flex-direction: column; }
        .cameras__settings_inputs > div input {
          height: 40px; }
          @media screen and (max-height: 675px) {
            .cameras__settings_inputs > div input {
              font-size: 14px;
              line-height: 16px;
              padding: 7px 16px; } }
    .cameras__settings_camera {
      padding: 0 0 30px 0;
      border-bottom: 1px solid #e0e0e0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start; }
      @media screen and (max-height: 675px) {
        .cameras__settings_camera {
          padding: 0 0 15px 0; } }
    .cameras__settings_cameraLIL {
      padding: 0 0 30px 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start; }
      .cameras__settings_cameraLIL label {
        margin: 30px 0 5px 0; }
      @media screen and (max-height: 675px) {
        .cameras__settings_cameraLIL {
          padding: 0 0 15px 0; } }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/cameras.scss"],"names":[],"mappings":"AAGA;EACE,+CAA+C;EAC/C,2BAA2B,EAAA;EAF7B;IAKI,gCAAgC;IAChC,wBAAwB,EAAA;;AAG5B;EACE,2BAA2B;EAC3B,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,YAAY,EAAA;EACZ;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,oBAAoB,EAAA;IAVrB;MAYG,mBAAmB,EAAA;IAErB;MACE,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;MACd,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,eAAe;MACf,oBAAoB,EAAA;MAVrB;QAYG,cAAc;QACd,mBAAmB,EAAA;EAIzB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa,EAAA;EAEjB;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;EAEnB;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IACnB;MACE,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,oBAAoB;MACpB,eAAe,EAAA;MARhB;QAUG,yBAAyB;QACzB,cAAc,EAAA;IAGlB;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA;IAEhB;MACE,aAAa;MACb,SAAS;MACT,kBAAkB;MAClB,WAAW;MACX,WAAW,EAAA;IArCd;MAwCG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,mBAAmB,EAAA;IA5CtB;MA+CG,6BAA6B;MAC7B,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,eAAe,EAAA;IAEjB;MACE,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;MACzB,aAAa;MACb,aAAa;MACb,sBAAsB,EAAA;IAExB;MACE,kBAAkB;MAClB,yBAAyB;MACzB,aAAa;MACb,aAAa;MACb,sBAAsB,EAAA;IAExB;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B,EAAA;MAC9B;QACE,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,+BAA+B;QAC/B,kBAAkB,EAAA;IAGtB;MACE,aAAa;MACb,sBAAsB;MACtB,SAAQ;MACR,mBAAmB,EAAA;MAJpB;QAMG,gBAAgB;QAChB,eAAe;QACf,iBAAiB,EAAA;IAGrB;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MACjB;QAJF;UAKI,gBAAgB;UAChB,eAAe;UACf,iBAAiB,EAAA,EAOpB;MALC;QATF;UAUI,gBAAgB;UAChB,eAAe;UACf,iBAAiB,EAAA,EAEpB;IACD;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,WAAW;MACX,0BAA0B;MAC1B,aAAa;MACb,gCAAgC,EAAA;IAElC;MACE,WAAW;MACX,aAAa;MACb,aAAa,EAAA;IAEf;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;MACT,kBAAkB,EAAA;IAEpB;MACE,6BAA6B;MAC7B,yBAAyB;MACzB,mBAAmB;MACnB,+BAA+B;MAC/B,cAAc,EAAA;IAEhB;MACE,aAAa;MACb,8BAA8B;MAC9B,WAAW;MACX,mBAAmB,EAAA;MAJpB;QAMG,kBAAkB,EAAA;MAEpB;QARF;UASI,mBAAmB,EAAA,EAkDtB;MAhDC;QACE,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB;QAClB,iBAAiB,EAAA;QAPlB;UASG,cAAc;UACd,gBAAgB;UAChB,eAAe;UACf,SAAS,EAAA;QAZZ;UAeG,cAAc;UACd,gBAAgB;UAChB,eAAe;UACf,iBAAiB,EAAA;QAEnB;UACE,kBAAkB;UAClB,WAAW;UACX,qBAAqB;UACrB,gBAAgB;UAChB,eAAe;UACf,iBAAiB;UACjB,cAAc;UACd,eAAe;UACf,oBAAoB,EAAA;UATrB;YAWG,0BAA0B,EAAA;MA1CjC;QA+CG,UAAU;QACV,aAAa;QACb,sBAAsB,EAAA;QAjDzB;UAmDK,YAAY,EAAA;UACZ;YApDL;cAqDO,eAAe;cACf,iBAAiB;cACjB,iBAAiB,EAAA,EAEpB;IAGL;MACE,mBAAmB;MACnB,gCAAgC;MAChC,aAAa;MACb,sBAAsB;MACtB,2BAA2B;MAC3B,uBAAuB,EAAA;MACvB;QAPF;UAQI,mBAAmB,EAAA,EAEtB;IACD;MACE,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,2BAA2B;MAC3B,uBAAuB,EAAA;MALxB;QAOG,oBAAoB,EAAA;MAEtB;QATF;UAUI,mBAAmB,EAAA,EAEtB","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.rw-widget-container {\n  border: 1px solid var(--LowEmphasis) !important;\n  box-shadow: none !important;\n  &:focus,\n  &:active {\n    border-color: #212121 !important;\n    outline: none !important;\n  }\n}\n.rw-popup-container {\n  box-shadow: none !important;\n  width: 100% !important;\n}\n\n.cameras {\n  width: 100%;\n  height: 100%;\n  &__button {\n    padding: 4px 20px;\n    text-align: center;\n    background: #fe6100;\n    border-radius: 4px;\n    color: #ffffff;\n    border: none;\n    font-size: 14px;\n    line-height: 24px;\n    cursor: pointer;\n    transition: all 0.5s;\n    &:hover {\n      background: #833505;\n    }\n    &_cancel {\n      padding: 4px 20px;\n      text-align: center;\n      background: #ffffff;\n      border-radius: 4px;\n      color: #fe6100;\n      border: none;\n      font-size: 14px;\n      line-height: 24px;\n      cursor: pointer;\n      transition: all 0.5s;\n      &:hover {\n        color: #ffffff;\n        background: #fe6100;\n      }\n    }\n  }\n  &__preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    display: flex;\n    width: 100vw;\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n  }\n&__settingsLil{\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: #00000070;\n  backdrop-filter: blur(2px);\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n  &__settings {\n    position: absolute;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background-color: #00000070;\n    backdrop-filter: blur(2px);\n    z-index: 5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    &_test {\n      width: 100%;\n      border: 2px solid #e0e0e0;\n      border-radius: 4px;\n      color: #fe6100;\n      padding: 4px 0;\n      text-align: center;\n      transition: all 0.4s;\n      cursor: pointer;\n      &:hover {\n        background-color: #fe6100;\n        color: #ffffff;\n      }\n    }\n    &_text {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 24px;\n      color: #9e9e9e;\n    }\n    &_buttons {\n      display: flex;\n      gap: 15px;\n      position: absolute;\n      bottom: 8px;\n      right: 20px;\n    }\n    h6 {\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 150%;\n      color: #9e9e9e;\n      margin-bottom: 10px;\n    }\n    .sysSettings{\n      border-top: 1px solid #E0E0E0;\n      width: 100%;\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 150%;\n      color: #9e9e9e;\n      padding: 10px 0;\n    }\n    &_modal {\n      position: relative;\n      width: calc(100% - 300px);\n      height: calc(90vh);\n      margin-top: 70px;\n      background-color: #ffffff;\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n    }\n    &_modalLIL {\n      position: relative;\n      background-color: #ffffff;\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n    }\n    &_img {\n      width: 100%;\n      height: 192px;\n      object-fit: contain;\n      object-position: center bottom;\n      &_bad {\n        width: 100%;\n        height: 100%;\n        background: #f5f5f5;\n        border: 2.54033px solid #e0e0e0;\n        border-radius: 4px;\n      }\n    }\n    &_header {\n      display: flex;\n      flex-direction: column;\n      gap:15px;\n      margin-bottom: 10px;\n      h1 {\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 150%;\n      }\n    }\n    &_descLIL {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      @media screen and (max-width: 1361px) {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 20px;\n      }\n      @media screen and (max-width: 970px) {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 14px;\n      }\n    }\n    &_ipLIL {\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n    }\n    &_container {\n      width: 100%;\n      height: calc(90vh - 170px);\n      display: flex;\n      border-bottom: 1px solid #e0e0e0;\n    }\n    &_containerLIL {\n      width: 100%;\n      height: 440px;\n      display: flex;\n    }\n    &_right {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 10px;\n      padding-left: 20px;\n    }\n    &_left {\n      min-width: calc(100% - 380px);\n      width: calc(100% - 380px);\n      padding: 0 12px 0 0;\n      border-right: 1px solid #e0e0e0;\n      overflow: auto;\n    }\n    &_inputs {\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n      margin-bottom: 30px;\n      label{\n        margin-bottom: 6px;\n      }\n      @media screen and (max-height: 675px) {\n        margin-bottom: 20px;\n      }\n      &_connection {\n        width: 100% !important;\n        margin-bottom: 10px;\n        position: relative;\n        background: #f3f4f6;\n        border: 1px solid #e0e0e0;\n        border-radius: 4px;\n        padding: 7px 10px;\n        h6 {\n          color: #9e9e9e;\n          font-weight: 600;\n          font-size: 12px;\n          margin: 0;\n        }\n        h5 {\n          color: #666666;\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 24px;\n        }\n        &_edit {\n          position: absolute;\n          right: 10px;\n          top: calc(50% - 12px);\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 24px;\n          color: #fe6100;\n          cursor: pointer;\n          transition: all 0.4s;\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n      > div {\n        width: 48%;\n        display: flex;\n        flex-direction: column;\n        input {\n          height: 40px;\n          @media screen and (max-height: 675px) {\n            font-size: 14px;\n            line-height: 16px;\n            padding: 7px 16px;\n          }\n        }\n      }\n    }\n    &_camera {\n      padding: 0 0 30px 0;\n      border-bottom: 1px solid #e0e0e0;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      @media screen and (max-height: 675px) {\n        padding: 0 0 15px 0;\n      }\n    }\n    &_cameraLIL {\n      padding: 0 0 30px 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      label {\n        margin: 30px 0 5px 0;\n      }\n      @media screen and (max-height: 675px) {\n        padding: 0 0 15px 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
